"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.step = void 0;
const errors_1 = require("../../errors");
const inspect_1 = require("../../utils/inspect");
const Value = __importStar(require("../../value"));
const Schedule = __importStar(require("../schedule"));
const Task = __importStar(require("../task"));
function step(schedule, task) {
    const { value } = Task.next_part(task);
    switch (value.kind) {
        case "Value.fn": {
            const index = Task.progress_index(task);
            const token = schedule.tokens[index];
            const span = token.span;
            throw new errors_1.ParsingError("Schedule.step should not meet Value.fn\n" +
                `value: ${(0, inspect_1.inspect)(Value.present(value))}`, { span });
        }
        case "Value.str":
        case "Value.pattern": {
            match_terminal(schedule, task, value);
            return;
        }
        case "Value.grammar": {
            Schedule.insert_grammar(schedule, value, Task.progress_index(task));
            return;
        }
    }
}
exports.step = step;
function match_terminal(schedule, task, value) {
    if (Task.progress_index(task) < schedule.tokens.length &&
        Value.terminal_match(value, schedule.tokens[Task.progress_index(task)])) {
        Schedule.insert_task(schedule, Task.advance(task, { index: Task.progress_index(task) + 1 }));
    }
}
//# sourceMappingURL=schedule-step.js.map